define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GrazingPermitPeriodDomain = void 0;
    class GrazingPermitPeriodDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: GrazingPermitPeriodDomain.Days, value: "Days" },
                    { key: GrazingPermitPeriodDomain.Weeks, value: "Weeks" },
                    { key: GrazingPermitPeriodDomain.Months, value: "Months" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[GrazingPermitPeriodDomain.Days] = 0;
                this.KeyIndex[GrazingPermitPeriodDomain.Weeks] = 1;
                this.KeyIndex[GrazingPermitPeriodDomain.Months] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Days"] = 0;
                this.ValueIndex["Weeks"] = 1;
                this.ValueIndex["Months"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.GrazingPermitPeriodDomain = GrazingPermitPeriodDomain;
    Object.defineProperty(GrazingPermitPeriodDomain, "Days", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "D"
    });
    Object.defineProperty(GrazingPermitPeriodDomain, "Weeks", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "W"
    });
    Object.defineProperty(GrazingPermitPeriodDomain, "Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "M"
    });
    Object.defineProperty(GrazingPermitPeriodDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
